import React from 'react'

import { Modal, ModalBody, ModalContent, ModalHeader } from '@nextui-org/modal'
import Image from 'next/image'

import { ImplementPostProvider } from '@/app/(global)/post-cre/components/RenderFormFeed'
import { TextareaPost } from '@/app/(global)/post-cre/components/TextareaPostProvider'
import ICONS from '@/assets/icons'

type ModalProps = {
  isOpen: boolean
  onTonggle: (v: any) => void
  isEdit?: boolean
}
export const ModalCreatePost = ({ isOpen, onTonggle, isEdit }: ModalProps) => {
  return (
    <Modal
      classNames={{
        base: 'overflow-visible',
      }}
      size="2xl"
      hideCloseButton
      isOpen={isOpen}
      onOpenChange={onTonggle}
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex items-center gap-6 border-b border-white/10">
              <Image
                onClick={onClose}
                className="cursor-pointer"
                src={ICONS.icCloseWhite}
                width={22}
                height={22}
                alt=""
              />
              <h3 className="text-base font-medium text-white">{isEdit ? 'Edit post' : 'Create post'}</h3>
            </ModalHeader>
            <ModalBody className="py-4 text-white">
              <TextareaPost type="post">
                <ImplementPostProvider onTonggleModal={onTonggle} />
              </TextareaPost>
            </ModalBody>
          </>
        )}
      </ModalContent>
    </Modal>
  )
}
